import submitFileDownloadChoice from './submitFileDownloadChoice';

export default [
  submitFileDownloadChoice,
];
